import { ButtonWrapper, type ButtonWrapperProps, cn } from '@endure/ui';

export interface NavButtonWrapperProps extends ButtonWrapperProps {}

export const NavButtonWrapper: React.FC<NavButtonWrapperProps> = ({ className, ...otherProps }) => (
  <ButtonWrapper
    className={cn(
      'border-line bg-elevated font-normal text-p3r text-foreground h-9 px-3 py-0 hover:bg-surface-2 hover:no-underline active:bg-surface-2',
      className,
    )}
    {...otherProps}
  />
);
